export class AccountActivateModel {
    public key: string;
    public secret: string;
    public password: string;
    public confirmPassword: string;
}
